import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      hovered: false,
    };
  },
  props: {
    text: {
      type: String,
      required: true,
    },
    price: {
      type: Number,
      required: true,
    },
    layout: {
      type: String,
      default: '',
    },
    win: {
      default: null,
    },
    sell: {
      default: null,
    },
    active: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    classModifiers() {
      return {
        'button-price': true,
        'button-price--hovered': this.hovered,
        [`button-price--${this.layout}`]: this.layout,
      };
    },
    isWin() {
      return this.win !== null;
    },
    isSell() {
      return this.sell !== null && this.sell > 0;
    },
    showWinOrSell() {
      return this.isLayoutDesktop && (this.isWin || this.isSell);
    },
    multiple() {
      const result = 100 / this.price
      const rounded = Math.round(result * 100) / 100
      return rounded % 1 === 0 ? Math.round(rounded) : rounded;
    },
  },
  methods: {
    onMouseOver() {
      this.hovered = true;
    },
    onMouseLeave() {
      this.hovered = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/v2/button-price/button-price.js